import { useState } from "react";

function useLocalStorage(key, initialValue) {
  // Estado inicial basado en lo que ya esté en localStorage o el valor inicial.
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.error("Error al obtener de localStorage", error);
      return initialValue;
    }
  });

  // Función para guardar datos en localStorage.
  const setValue = (value) => {
    try {
      const valueToStore = value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);
      window.localStorage.setItem(key, JSON.stringify(valueToStore));
    } catch (error) {
      console.error("Error al guardar en localStorage", error);
    }
  };

  return [storedValue, setValue];
}

export default useLocalStorage;
